import { render, staticRenderFns } from "./DigitalRecordQuery.vue?vue&type=template&id=7cf6bea9&scoped=true"
import script from "./DigitalRecordQuery.vue?vue&type=script&lang=js"
export * from "./DigitalRecordQuery.vue?vue&type=script&lang=js"
import style0 from "./DigitalRecordQuery.vue?vue&type=style&index=0&id=7cf6bea9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cf6bea9",
  null
  
)

export default component.exports